import React, { useEffect, useState } from "react";

import Navbar from "./Navbar";
import HeroSection from "./HeroSection";

import Footer from "./Footer";

const Home = () => {
  //   const [renderr,setRender] =useState(0)

  console.log("Reloadd", localStorage.getItem("reload"));
  if (localStorage.getItem("reload")) {
    localStorage.clear();
    window.location.reload();
  }

  return (
    <div>
      <Navbar />

      <HeroSection />
      <div className="hidden">render</div>
      <Footer />
    </div>
  );
};

export default Home;
